import React from "react";
import styles from "./DashboardFooter.module.scss";

function DashboardFooter({ accountType, hasSales }) {
  if (accountType === "NonProfit") {
    return (
      <div>
        <h3 className={styles.heading}>You Can</h3>
        {hasSales ? (
          <ul className={styles.linkList}>
            <li>
              <a href="#">You have received donation. Check details here</a>
            </li>
            <li>
              <a href="#">See how your videos have performed</a>
            </li>
            <li>
              <a href="#">Cash out your donations to your bank account</a>
            </li>
          </ul>
        ) : (
          <ul className={styles.linkList}>
            <li>
              <a href="#">Upload your video</a>
            </li>
            <li>
              <a href="#">
                Invite a third party to be part of raising funds for you
              </a>
            </li>
            <li>
              <a href="#">Here are some tips to maximize views of your video</a>
            </li>
            <li>
              <a href="#">
                How to use your video squirrel video in email campaign
              </a>
            </li>
            <li>
              <a href="#">
                How to use your video squirrel video in a text campaign
              </a>
            </li>
            <li>
              <a href="#">Embed your videos on your website or donation page</a>
            </li>
          </ul>
        )}
      </div>
    );
  } else if (accountType === "Political") {
    return (
      <div>
        <h3 className={styles.heading}>You Can</h3>
        {hasSales ? (
          <ul className={styles.linkList}>
            <li>
              <a href="#">View campaign donations</a>
            </li>
            <li>
              <a href="#">Download campaign donor data</a>
            </li>
            <li>
              <a href="#">Cash out</a>
            </li>
          </ul>
        ) : (
          <ul className={styles.linkList}>
            <li>
              <a href="#">Upload your campaign video</a>
            </li>
            <li>
              <a href="#">How to maximize views for your video</a>
            </li>
            <li>
              <a href="#">
                Embed your video on your political campaign website
              </a>
            </li>
            <li>
              <a href="#">Run a text campaign with your video</a>
            </li>
            <li>
              <a href="#">
                Invite a third party to create donation videos for you
              </a>
            </li>
          </ul>
        )}
      </div>
    );
  } else {
    return (
      <div>
        <h3 className={styles.heading}>You Can</h3>
        {hasSales ? (
          <ul className={styles.linkList}>
            <li>
              <a href="#">Check out your orders</a>
            </li>
            <li>
              <a href="#">Check reporting of your videos</a>
            </li>
            <li>
              <a href="#">Cash out</a>
            </li>
          </ul>
        ) : (
          <ul className={styles.linkList}>
            <li>
              <a href="#">Share your video</a>
            </li>
            <li>
              <a href="#">Start an influencer program</a>
            </li>
            <li>
              <a href="#">
                Create an opportunity for others to create shoppable videos for
                you
              </a>
            </li>
            <li>
              <a href="#">Get views for your video</a>
            </li>
          </ul>
        )}
      </div>
    );
  }
}

export default DashboardFooter;
